import { Context, createContext, useContext } from 'react';
import type SendbirdChat from '@sendbird/chat';
import type { GroupChannelModule } from '@sendbird/chat/groupChannel';
import type { OpenChannelModule } from '@sendbird/chat/openChannel';
import type { ModuleNamespaces } from '@sendbird/chat/lib/__definition';

export type SendbirdChatType = SendbirdChat &
  ModuleNamespaces<[GroupChannelModule, OpenChannelModule]>;

export type TSendbirdReadyContext = {
  sdk: SendbirdChatType | null;
};

export const SendbirdReadyContext: Context<TSendbirdReadyContext> =
  createContext<TSendbirdReadyContext>({
    sdk: null,
  });

export const useSendbirdReadyContext = (): TSendbirdReadyContext => {
  const context = useContext(SendbirdReadyContext);
  if (!context) {
    throw new Error(
      'useSendbirdReadyContext must be used within SendbirdReadyContext.Provider',
    );
  }
  return context;
};
